<template>
    <div class="application">
        <el-card>
            <div class="user">
                <div class="user-info">
                    <div class="user-greeting">
                        <el-avatar :size="64"
                                   :src="userInfo.avatar || require('@/assets/app/default_head.png')"
                                   @error="() => true">
                            <img src="@/assets/app/default_head.png" alt="默认头像"/>
                        </el-avatar>
                        <div style="margin-left: 20px">
                            <div class="greeting-text">{{ userInfo.name }}，{{ $d(greeting[0]) }}。</div>
                            <div class="blessing-text">{{ $d(greeting[1]) }}</div>
                        </div>
                    </div>
                    <div class="profile-details">
                        <div class="detail-item">
                            <i class="el-icon-office-building"></i>
                            <span>{{ userInfo.deptName }}</span>
                        </div>
                        <div class="detail-item">
                            <i class="el-icon-user"></i>
                            <span>{{ userInfo.postName }}</span>
                        </div>
                    </div>
                </div>
                <div class="user-task">
                    <div>
                        <span>{{ todos.length }}</span>
                        <div>
                            <div>
                                {{ $d('待办事项') }}
                                <i class="el-icon-s-claim header-icon"></i>
                            </div>
                            <div class="color-bar">
                                <div style="width: 15%"></div>
                                <div style="width: 35%"></div>
                                <div style="width: 50%"></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span>{{ unreadMessage }}</span>
                        <div>
                            <div>
                                {{ $d('未读消息') }}
                                <i class="el-icon-message-solid header-icon"></i>
                            </div>
                            <div class="color-bar">
                                <div class="none"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>

        <el-row :gutter="20">
            <!-- 应用列表 -->
            <el-col :span="14">
                <el-card class="app-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <div class="header-title">
                            <i class="el-icon-s-grid header-icon"></i>
                            <span>{{ $d('应用中心') }}</span>
                        </div>
                    </div>
                    <div class="app-list">
                        <div v-for="(item, index) in navList"
                             :key="index"
                             class="app-item"
                             @click="selectApp(index)">
                            <div :class="['app-icon', 'icon-' + item.code.toLowerCase()]">
                            </div>
                            <div class="app-info">
                                <div class="app-name">{{ $d(item.name) }}</div>
                                <div class="app-code">e-{{ item.code }}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
                <!-- 待办事项 -->
                <el-card class="todo-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <div class="header-title">
                            <i class="el-icon-s-claim header-icon"></i>
                            <span>{{ $d('待办事项') }}</span>
                        </div>
                    </div>
                    <div class="todo-list">
                        <template v-if="todos && todos.length">
                            <div v-for="(todo, index) in todos"
                                 :key="index"
                                 class="todo-item"
                                 @click="handleTodoClick(todo)">
                                <div class="todo-main">
                                    <div class="todo-title">{{ todo.procDefName }}</div>
                                    <div class="todo-content">{{ todo.taskDesc }}</div>
                                </div>
                                <div class="todo-info">
                                    <el-tag :type="todo.type" size="small">{{ todo.taskName }}</el-tag>
                                    <span>{{ todo.createTime }}</span>
                                </div>
                            </div>
                        </template>
                        <div v-else class="empty-state">
                            <img src="@/assets/app/default.png" alt="暂无数据">
                            <p>{{ $d('暂无待办') }}</p>
                        </div>
                    </div>
                </el-card>
            </el-col>

            <!-- 快捷操作卡片 -->
            <el-col :span="10">
                <el-card class="quick-actions" shadow="hover">
                    <div slot="header" class="card-header">
                        <div class="header-title">
                            <i class="el-icon-star-on header-icon"></i>
                            <span>{{ $d('菜单收藏') }}</span>
                        </div>
                    </div>
                    <div class="favorite-grid">
                        <template v-if="favoriteNav && favoriteNav.length">
                            <div v-for="(nav, index) in favoriteNav"
                                 :key="index"
                                 class="favorite-item"
                                 @click="selectItem(nav)">
                                <div class="favorite-content">
                                    <span>{{ $d(nav.name) }}</span>
                                    <span :class="nav.isFavorite === 'Y' ? 'el-icon-star-on' : 'el-icon-star-off'"
                                          class="star"
                                          @click.stop="toggleFavorite(nav)">
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div v-else class="empty-state">
                            <img src="@/assets/app/default.png" alt="暂无数据">
                            <p>{{ $d('暂无收藏菜单') }}</p>
                        </div>
                    </div>
                </el-card>
                <!-- 系统公告 -->
                <el-card class="notice-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <div class="header-title">
                            <i class="el-icon-message-solid header-icon"></i>
                            <span>{{ $d('系统公告') }}</span>
                        </div>
                    </div>
                    <div class="notice-list">
                        <template v-if="notices && notices.length">
                            <div v-for="(notice, index) in notices"
                                 :key="index"
                                 class="notice-item"
                                 @click.stop="openNoticeDialog(notice)"
                                 style="cursor: pointer">
                                <div class="notice-main">
                                    <div class="notice-title">{{ notice.title }}</div>
                                    <div class="notice-content">{{ notice.content }}</div>
                                </div>
                                <div class="notice-time">
                                    <i class="el-icon-time"></i>
                                    <span>截止至: {{ notice.endTime.split(' ')[0] }}</span>
                                </div>
                            </div>
                        </template>
                        <div v-else class="empty-state">
                            <img src="@/assets/app/default.png" alt="暂无数据">
                            <p>{{ $d('暂无公告') }}</p>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 公告详情弹窗 -->
        <etao-dialog
            title="公告详情"
            ref="pDialog"
            :visible.sync="showNoticeDialog"
            width="600px"
            :close-on-click-modal="true"
            append-to-body
            :z-index="10000"
        >
            <div v-if="showNoticeDialog">
                <h3 style="margin-bottom: 15px">{{ currentNotice.title || '' }}</h3>
                <p style="color: #666; margin-bottom: 10px;">
                    <i class="el-icon-time"></i>
                    截止时间：{{ currentNotice.endTime ? currentNotice.endTime.split(' ')[0] : '无' }}
                </p>
                <div style="border-top: 1px solid #eee; padding-top: 15px; line-height: 1.7;">
                    {{ currentNotice.content || '无公告内容' }}
                </div>
            </div>
            <span slot="footer">
                <el-button @click="showNoticeDialog = false">关闭</el-button>
            </span>
        </etao-dialog>
    </div>
</template>

<script>
import blessings from '@/components/index/data/blessings'
import EtaoDialog from '@/comp/etao-dialog.vue'

export default {
    name: 'indexApp',
    components: {
        EtaoDialog
    },
    computed: {
        navList () {
            return this.$store.state.etao.navList
        },
        favoriteNav () {
            let list = []
            for (let app of this.navList) {
                for (let module of app.children || []) {
                    for (let nav of module.children || []) {
                        if (nav.isFavorite === 'Y') {
                            list.push(nav)
                        }
                    }
                }
            }
            return list
        },
        greeting () {
            const now = new Date()
            const hour = now.getHours()
            const r = Math.floor(Math.random() * 5)

            if (hour >= 0 && hour < 6) {
                return ['夜深了', blessings[4][r]]
            } else if (hour >= 6 && hour < 9) {
                return ['早上好', blessings[0][r]]
            } else if (hour >= 9 && hour < 12) {
                return ['上午好', blessings[1][r]]
            } else if (hour >= 12 && hour < 14) {
                return ['中午好', blessings[2][r]]
            } else if (hour >= 14 && hour < 18) {
                return ['下午好', blessings[3][r]]
            } else {
                return ['晚上好', blessings[4][r]]
            }
        }
    },
    watch: {
        userInfo: {
            handler (value) {
                console.log(1, value)
            },
            deep: true
        }
    },
    methods: {
        selectApp: function (index) {
            const navLog = this.etao.common.getData('navLog') || {}
            navLog.listIndex = index
            window.openNav()
            window.selectIndex(index)
        },
        lastVisit: function (menuCode) {
            const navLog = this.etao.common.getData('navLog') || {}
            if (!navLog['lastVisit'] || !navLog['lastVisit'][menuCode]) {
                return false
            }
            return navLog['lastVisit'][menuCode]['menuName']
        },
        getUserInfo: function () {
            const user = this.etao.common.getData('userInfo')
            if (user) {
                this.etao.requests.get({
                    url: '/etao-system/user/detail',
                    data: {id: user['userId']},
                    successMessage: false,
                    success: res => {
                        this.$set(this, 'userInfo', res.data)
                        console.log(this.userInfo)
                    }
                })
            }
        },
        getNotices () {
            this.etao.requests.get({
                url: '/etao-resource/notice/select-cur-notice-by-limit',
                data: {
                    size: 5
                },
                successMessage: false,
                success: res => {
                    // 关键修复：按发布时间降序排序（最新的在前）
                    this.notices = res.data.sort((a, b) => {
                        const timeA = new Date(a.releaseTime).getTime()
                        const timeB = new Date(b.releaseTime).getTime()
                        return timeB - timeA
                    })
                    console.log('排序后的公告：', this.notices)
                }
            })
        },
        getMineUnread () {
            this.etao.requests.get({
                url: '/etao-resource/unified-message/business/unread-count',
                successMessage: false,
                success: res => {
                    this.unreadMessage = res.data || 0
                }
            })
        },
        getTodos () {
            // this.etao.requests.get({
            //     url: '/etao-flow/flowable/task/todoList',
            //     data: {
            //         size: 5,
            //         current: 1
            //     },
            //     successMessage: false,
            //     success: res => {
            //         this.todos = res.data.records
            //     }
            // })
        },
        async toggleFavorite (item) {
            let url = '/etao-system/user-menu/submit'
            if (item.isFavorite === 'Y') {
                url = '/etao-system/user-menu/remove-user-menu'
            }
            this.etao.requests.post({
                url: url,
                data: {
                    menuId: item.id
                },
                successMessage: false,
                success: res => {
                    if (res.code === 200) {
                        item.isFavorite = item.isFavorite === 'Y' ? 'N' : 'Y'
                    }
                }
            })
        },
        selectItem (item) {
            if (item.isOpen) {
                window.open(item.path)
            } else {
                window.selectNav(item)
            }
        },
        handleTodoClick (todo) {
            for (const app of this.navList) {
                for (const module of app.children || []) {
                    for (const nav of module.children || []) {
                        if (nav.name === '待办任务') {
                            if (nav.isOpen) {
                                window.open(nav.path)
                            } else {
                                window.selectNav(nav)
                            }
                            return
                        }
                    }
                }
            }
        },

        openNoticeDialog (notice) {
            this.currentNotice = JSON.parse(JSON.stringify(notice))
            this.$nextTick(() => {
                this.showNoticeDialog = true
            })
        }
    },
    data () {
        return {
            expend: false,
            userInfo: {},
            notices: [],
            unreadMessage: 0,
            todos: [],
            showNoticeDialog: false,
            currentNotice: {}
        }
    },
    mounted () {
        window.test = this
        setTimeout(() => {
            const user = this.etao.common.getData('userInfo')
            if (!user) {
                window.test.getUserInfo()
            } else {
                window.test.getNotices()
                window.test.getMineUnread()
                window.test.getTodos()
                this.$set(this, 'userInfo', user)
            }
        }, 300)
    }
}
</script>

<style scoped src="./css/index-app.css"></style>
<style scoped src="./css/index-app-user.css"></style>
<style scoped src="./css/index-app-icon.css"></style>



// WEBPACK FOOTER //
// src/components/index/indexApp.vue